import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[kd-number]'
})
export class OnlyNumberDirective {
  @Input('kd-number') kdNumInput=false;
  @Input('allowDecimal') allowDecimal=false;
  @Input('allowNewgative') allowNewgative=false;
    constructor(private el: ElementRef) { }


  ngAfterViewInit(){
      // let self=this;
      // this.el.nativeElement.addEventListener('keyup', this.checkChanges.bind(this, self.el));
  }
  
  @HostListener('input', ['$event'])
  onKeyDown(ev: KeyboardEvent) {
    const input = ev.target as HTMLInputElement;
    if(this.kdNumInput){
      if(input.value.length == 1 && input.value == '.'){
        input.value="";
      }
      if(input.value.length > 0 && input.value[0] == '-' && !this.allowNewgative) {
        input.value="";
      }
      if(!this.allowDecimal) {
        input.value = String(input.value.replace(/\D+/g, ''));
      }else {
        input.value = String(input.value
          // Remove anything that isn't valid in a number
          .replace(/[^\d-.]/g, '')
          // Remove all dashes unless it is the first character
          .replace(/(?!^)-/g, '')
          // Remove the last period if there is already one
          .replace(/(\..*)\.$/, '$1')
          // Remove all periods unless it is the last one
          .replace(/\.(?=.*\.)/g, ''));
      }
    }
  }

}
